module.exports = __webpack_public_path__ + "static/award-1-a1c6d5b7fda178eb4198ba5f5113d9d1.svg";